import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequestFiltersContarDatos } from '../../../dto/powerbi/request.filters.contardatos.dto';
import { PowerbiService } from '../../../services/powerbi.service';
import { ResponseEmbedconfigDto } from '../../../dto/powerbi/response.embedconfig.dto';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-visualizar-administrador',
  templateUrl: './visualizar-administrador.component.html',
  styleUrl: './visualizar-administrador.component.scss',
})
export class VisualizarAdministradorComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  yearsFilter: number[] = [];
  currentYear = new Date().getFullYear();
  selectedYear: number;

  //Reportes PowerBI
  embedUrl!: string;
  embedToken!: string;
  accessToken!: string;
  reportId!: string;
  groupId!: string;
  renderizarReporte = false;

  procesosText: any = {};

  constructor(
    private pbiService: PowerbiService,
    private readonly alertaModalService: AlertaModalService,
    private readonly translate: TranslateService
  ) {
    this.selectedYear = this.currentYear;
    this.translate.stream('procesos-comun').forEach(text => {
      for (const key of Object.keys(text)) {
        this.procesosText[key] = text[key];
      }
    });
  }

  ngOnInit() {
    for (let i = 0; i < 5; i++) {
      // Se deja 2024 porque es el año en el que se inicia el proyecto
      const yearAdd = this.currentYear < 2024 ? 2024 : this.currentYear;
      if (!this.yearsFilter.includes(yearAdd)) {
        this.yearsFilter.push(yearAdd);
      }
      this.currentYear--;
    }

    this.pbiService
      .getReporte('ADMINFUNCIONALIDAD')
      .subscribe((data: ResponseEmbedconfigDto) => {
        this.embedUrl = data.reportDetails.embedUrl;
        this.embedToken = data.embedToken.token;
        this.accessToken = data.accessToken;
        this.reportId = data.reportDetails.id;
        this.groupId = data.reportDetails.workspaceId;
        this.renderizarReporte = true;
      });
  }

  downloadExcel() {
    const filters: RequestFiltersContarDatos[] = [
      {
        name: 'Filtro_Year',
        value: this.selectedYear,
      },
    ];

    this.pbiService.exportExcel(filters, 'FUNCIONALIDAD').subscribe(
      (response: Blob) => {
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'Contar_Datos_MDJ.xlsx'; // Nombre del archivo que se descargará
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(anchor);
        if (response) {
          this.alertaModalService.exito(
            this.procesosText['exito'],
            this.procesosText['descarga-archivo']
          );
        }
      },
      error => {
        this.alertaModalService.error(this.procesosText['error-descarga']);
      }
    );
  }
}
